import { Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Home from "./pages/Home";
import GettingStarted from "./pages/GettingStarted";
import Ssr from "./pages/Ssr";
import Ssg from "./pages/Ssg";
import Seo from "./pages/Seo";
import Deployment from "./pages/Deployment";

interface AppProps {
  initialRouteData?: Record<string, Record<string, unknown>>;
}

export default function App({ initialRouteData = {} }: AppProps) {
  const location = useLocation();
  const routeData = initialRouteData[location.pathname] ?? {};

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/getting-started" element={<GettingStarted />} />
      <Route path="/ssr" element={<Ssr />} />
      <Route path="/ssg" element={<Ssg />} />
      <Route path="/seo" element={<Seo />} />
      <Route path="/deployment" element={<Deployment />} />
    </Routes>
  );
}
